"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Editor, List } from "@/app/(main)/(club)/mes-clubs/[id]/components/(wanted-profiles)";
import ToggleEditIcon from "@/app/(main)/(club)/mes-clubs/[id]/components/toggle-edit-icon";
import { useAddSearchedJob, useRemoveSearchedJob, useSearchedJobs } from "@/app/(main)/(club)/mes-clubs/[id]/hooks";
import { CardTitle } from "@/components/global/titles/card-title";
interface WantedProfilesProps {
  club: {
    slug: string;
  };
  isPresident?: boolean;
}
export const WantedProfiles = t0 => {
  const $ = _c(23);
  const {
    club,
    isPresident: t1
  } = t0;
  const isPresident = t1 === undefined ? false : t1;
  const [isEditing, setIsEditing] = useState(false);
  const [shakeIndex, setShakeIndex] = useState(null);
  const {
    data: t2,
    isLoading,
    error: queryError
  } = useSearchedJobs(club.slug);
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const profils = t3;
  const addSearchedJobMutation = useAddSearchedJob(club.slug);
  const removeSearchedJobMutation = useRemoveSearchedJob(club.slug);
  let t4;
  if ($[2] !== addSearchedJobMutation || $[3] !== profils) {
    t4 = async value => {
      const normalizedInput = value.toLowerCase().trim();
      const existingIndex = profils.findIndex(p => p.toLowerCase().trim() === normalizedInput);
      if (existingIndex !== -1) {
        setShakeIndex(existingIndex);
        setTimeout(() => setShakeIndex(null), 300);
        return;
      }
      await addSearchedJobMutation.mutateAsync(value);
    };
    $[2] = addSearchedJobMutation;
    $[3] = profils;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleAddProfil = t4;
  let t5;
  if ($[5] !== isEditing || $[6] !== isPresident) {
    t5 = isPresident && <div className="absolute right-4 top-4"><ToggleEditIcon isEditing={isEditing} onToggle={() => setIsEditing(!isEditing)} /></div>;
    $[5] = isEditing;
    $[6] = isPresident;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = isLoading ? undefined : profils.length;
  let t7;
  if ($[8] !== t6) {
    t7 = <CardTitle title={"Profils recherch\xE9s"} count={t6} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== addSearchedJobMutation || $[11] !== handleAddProfil || $[12] !== isEditing || $[13] !== isLoading || $[14] !== profils || $[15] !== queryError || $[16] !== removeSearchedJobMutation || $[17] !== shakeIndex) {
    t8 = isEditing ? <Editor onSubmit={handleAddProfil} isPending={addSearchedJobMutation.isPending} error={addSearchedJobMutation.error} profils={profils} shakeIndex={shakeIndex} removeMutation={removeSearchedJobMutation} addMutation={addSearchedJobMutation} /> : <List isLoading={isLoading} queryError={!!queryError} profils={profils} />;
    $[10] = addSearchedJobMutation;
    $[11] = handleAddProfil;
    $[12] = isEditing;
    $[13] = isLoading;
    $[14] = profils;
    $[15] = queryError;
    $[16] = removeSearchedJobMutation;
    $[17] = shakeIndex;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className="rounded relative bg-white p-4 border border-light-grey pb-8">{t5}{t7}{t8}</div>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};